import { types, actions } from './requests'
export const PRODUCTIONINDEX_TYPES = {
    ...types('PRODUCTIONINDEX'),
}
export const PRODUCTIONINDEX_ACTIONS = {
    ...actions('PRODUCTIONINDEX'),
}